import React, { useRef, useState } from 'react';
import { Alert, Button, Col, Container, Form, Row, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setUpdateUserInfo } from '../../redux/modules/auth';
import { apiUrl, businessName } from '../../utils/consts';
import { uploadFile } from '../../utils/files';

const select = state => {
  return {
    user: state.auth.user,
    userId: state.auth.userId,
    token: state.auth.token
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setUpdateUserInfo: payload => dispatch(setUpdateUserInfo(payload))
  };
}

const banks = [
  'Banco Agrario de Colombia',
  'Banco AV Villas',
  'Banco BBVA',
  'Banco BCSC',
  'Banco Citibank',
  'Banco Compartir',
  'Banco Coopcentral',
  'Banco Credifinanciera S.A.C.F',
  'Banco Davivienda',
  'Banco de Bogotá',
  'Banco de la República',
  'Banco de Occidente',
  'Banco Falabella',
  'Banco Finandina',
  'Banco GNB Sudameris',
  'Banco Itaú Corpbanca Colombia S.A.',
  'Banco Multibank S.A.',
  'Banco Mundo Mujer',
  'Banco Pichincha',
  'Banco Popular',
  'Banco Santander de Negocios Colombia S.A.',
  'Banco Serfinanciera',
  'Bancoldex',
  'Bancolombia',
  'Bancoomeva',
  'BNP Paribas',
  'Coltefinanciera',
  'Compensar',
  'Confiar Cooperativa Financiera',
  'Cooperativa Financiera Cootrafa',
  'Cooperativa Financiera de Antioquia',
  'Red Multibanca Colpatria'
];

function ConnectedUserDocuments(props) {

  const { user, userId, token } = props;
  const [validated, setValidated] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [bankAccountNumber, setBankAccountNumber] = useState(user.bankAccountNumber || '');
  const [bankAccountType, setBankAccountType] = useState(user.bankAccountType || 'Ahorros');
  const [bankName, setBankName] = useState(user.bankName || banks[0]);
  const [bankAccountCertificate, setBankAccountCertificate] = useState();
  const [bankAccountCertificateName, setBankAccountCertificateName] = useState(user.bankAccountCertificate ? `${user.bankAccountCertificate.split('com/')[1]}` : '');
  const bankAccountCertificateInput = useRef(null);

  const getShortFileName = fileName => {
    const maxLength = 25;
    return fileName.length > maxLength ? `${fileName.substring(0, maxLength)}...` : fileName
  };

  const displayedBankAccountCertificateName = getShortFileName(bankAccountCertificateName);

  const handleFileChange = event => {
    if (event.target.files[0]) {
      setBankAccountCertificate(event.target.files);
      setBankAccountCertificateName(event.target.files[0].name);
    }
  };

  const handleSubmit = async event => {
    event.preventDefault();
    event.stopPropagation();

    setValidated(true);

    const form = event.currentTarget;

    if (form.checkValidity()) {
      setSubmitting(true);

      const bankAccountCertificateUrl = await uploadFile(bankAccountCertificate[0]);
      const updateProm = await fetch(`${apiUrl}/users/update/files`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userId,
          token,
          businessName,
          bankAccountCertificate: bankAccountCertificateUrl,
          bankName,
          bankAccountNumber,
          bankAccountType
        })
      });

      const updateJson = await updateProm.json();

      if (updateJson.success) alert('Datos actualizados correctamente.');
      else alert('Error. inténtalo de nuevo.');

      props.setUpdateUserInfo({ update: true });
      setSubmitting(false);
    }
  };

  return (
    <div className="user-documents-component">
      <Container>
        <Row>
          <Col xs={12}>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <h2>Documentos</h2>
              <hr />

              <Alert variant="info">
                En esta sección podrás subir los documentos relacionados con tu información bancaria, de esta forma podremos hacer los desembolsos de los productos que vendas.
              </Alert>

              <Form.Row>
                <Col xs={12}>
                  <h3>Información bancaria</h3>
                  <hr />
                </Col>

                <Form.Group as={Col} lg={4}>
                  <Form.Label>Número de cuenta bancaria:</Form.Label>
                  <Form.Control
                    type="text"
                    value={bankAccountNumber}
                    onChange={e => setBankAccountNumber(e.target.value)}
                    placeholder="Número de cuenta bancaria"
                    maxLength={50}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Ingresa una cuenta válida.
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} lg={4}>
                  <Form.Label>Tipo de cuenta:</Form.Label>
                  <Form.Control
                    as="select"
                    custom="true"
                    value={bankAccountType}
                    onChange={e => setBankAccountType(e.target.value)}
                    required
                  >
                    <option value="Ahorros">Ahorros</option>
                    <option value="Corriente">Corriente</option>
                    <option value="Nomina">Nómina</option>
                  </Form.Control>

                  <Form.Control.Feedback type="invalid">
                    Ingresa un tipo de cuenta válido.
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} lg={4}>
                  <Form.Label>Banco:</Form.Label>
                  <Form.Control
                    as="select"
                    custom="true"
                    name="bankName"
                    value={bankName}
                    onChange={e => setBankName(e.target.value)}
                    required
                  >
                    {
                      banks.map(bank => <option key={bank} value={bank}>{bank}</option>)
                    }
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    Ingresa una entidad bancaria válida.
                  </Form.Control.Feedback>
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} lg={6}>
                  <Form.Label>Certificado de cuenta bancaria (formato PDF):</Form.Label>
                  <Form.Control
                    type="file"
                    ref={bankAccountCertificateInput}
                    files={bankAccountCertificate}
                    onChange={handleFileChange}
                    accept="application/pdf"
                    hidden
                  />
                  <div className="form-custom-file-input">
                    <Button variant="outline-primary" onClick={() => bankAccountCertificateInput.current.click()} style={{ marginRight: '10px' }}>
                      Selecciona un archivo
                    </Button>
                    {displayedBankAccountCertificateName || 'No hay archivos seleccionados'}
                  </div>
                  {
                    validated && !bankAccountCertificateName &&
                    <div className="invalid-input-value">
                      Sube un documento válido.
                    </div>
                  }
                </Form.Group>

              </Form.Row>

              <div className="center">
                <Button type="submit" variant="outline-primary" style={{ width: "220px" }} disabled={submitting}>
                  {
                    submitting ? <Spinner size="sm" animation="border" variant="warning" /> : 'Guardar'
                  }
                </Button>
              </div>

            </Form>
            <br /><br />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

const UserDocuments = connect(select, mapDispatchToProps)(ConnectedUserDocuments);

export default UserDocuments;
